import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IReducer } from '../../redux/configureStore';
import { eraserList } from '../../redux/duck/legado/clientsApp';
import { Logout } from '../../redux/fetchActions/tokens';
import { PATHS } from '../../routes';
import SideMenu from '../../shared/components/SideMenu';
import Frame from './components/Frame';
import RenderSideMenuButtons from './components/SideMenuButtons';
import WelcomeApp from './components/WelcomeApp';

function LegadoPage() {
  const isLoggedContext = useSelector(
    (reducer: IReducer) => reducer.loginAuth.isAuthenticated
  );

  const loginToken = localStorage.getItem('loginToken');
  const dispatch = useDispatch();
  const history = useHistory();

  const [appComponent, setAppComponent] = useState(<WelcomeApp />);

  useEffect(() => {
    if (history.action === 'POP') {
      history.push(PATHS.apis);
    }

    if (!isLoggedContext) {
      dispatch(Logout());
      history.push(PATHS.login);
    }
  }, [isLoggedContext]);

  useEffect(() => {
    if (loginToken !== null) {
      dispatch(eraserList());
    } else {
      history.push(PATHS.login);
    }
  }, [loginToken]);

  return (
    <Frame.Base>
      <SideMenu setAppComponent={setAppComponent}>
        <RenderSideMenuButtons setAppComponent={setAppComponent} />
      </SideMenu>
      <Frame.App>{appComponent}</Frame.App>
    </Frame.Base>
  );
}

export default LegadoPage;
